export const MY_SOFTIES_PAGE_SIZE = 48;
